import { defineAsyncComponent } from 'vue'
import { stellaModal } from '../stella/StellaModal'

export function openFeatureSettings() {
  stellaModal.open({
    content: defineAsyncComponent(
      () => import('/@/core/feature/FeatureSettingsModalContent.vue'),
    ),
  })
}
